import { BigNumber, FormattedNumber } from '../../../../../../components'
import { GetWorkspaceCreditsUsageQuery } from '@indigohive/cogfy-types/endpoints/getWorkspaceCreditsUsage'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useWorkspaceCreditsAvailable, useWorkspaceCreditsUsage } from '../../../../../../hooks'
import { UUID } from '@indigohive/cogfy-types'

export type CreditsUsageCardsProps = {
  startDate?: Date
  endDate?: Date
  collectionId?: UUID
}

export function CreditsUsageCards (props: CreditsUsageCardsProps) {
  const { startDate, endDate, collectionId } = props
  const { t } = useTranslation()

  const params = useParams<{ workspace: string }>()
  const workspace = params.workspace!

  const {
    data: workspaceCreditsAvailable,
    isError: errorWorkspaceAvailable,
    isLoading: loadingWorkspaceAvailable,
    refetch: refetchWorkspaceCreditsAvailable
  } = useWorkspaceCreditsAvailable(workspace)

  const query: GetWorkspaceCreditsUsageQuery = {
    startDate,
    endDate,
    collectionId
  }
  const {
    data: workspaceCreditsUsage,
    isError: errorWorkspaceUsage,
    isLoading: loadingWorkspaceUsage,
    refetch: refetchWorkspaceCreditsUsage
  } = useWorkspaceCreditsUsage(workspace, query)

  return (
    <div className="flex flex-row gap-4 min-h-40">
      <BigNumber.Card
        error={errorWorkspaceAvailable}
        loading={loadingWorkspaceAvailable}
        onRefetchClick={() => { refetchWorkspaceCreditsAvailable() }}
      >
        <span>{t('workspaceUsagePage:Credits available')}</span>
        <BigNumber.Number>
          <FormattedNumber value={workspaceCreditsAvailable || 0} />
        </BigNumber.Number>
      </BigNumber.Card>

      <BigNumber.Card
        error={errorWorkspaceUsage}
        loading={loadingWorkspaceUsage}
        onRefetchClick={() => { refetchWorkspaceCreditsUsage() }}
      >
        <span className="text-center">{t('workspaceUsagePage:Credits used in the selected period')}</span>
        <BigNumber.Number>
          <FormattedNumber value={workspaceCreditsUsage || 0} />
        </BigNumber.Number>
      </BigNumber.Card>
    </div>
  )
}
